import * as React from 'react';
import styled from 'styled-components';

import { Field, useField } from 'react-final-form';

import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';

const FormSwitch = ({
  name,
  options,
  pickerColor,
  dataId,
  isBig = false,
  disabled = false,
  ...restProps
}) => {
  const field = useField(name).input.value;

  const box = document.getElementById('switch-element');

  const [x, setX] = useState(0);

  const { t } = useTranslation();

  const onCheck = useCallback((input, option, idx, ev) => {
    input.onChange(option.value);
    setX(idx * ev.target.clientWidth);
  }, []);

  React.useEffect(() => {
    if (box && field === options[1].value) setX(box?.clientWidth / 2);
  }, [box, field]);

  return (
    <Field defaultValue={options[0].value} name={name}>
      {({ input, meta }) => {
        return (
          <SSwitch
            data-id={dataId}
            isBig={isBig}
            id={'switch-element'}
            {...restProps}
          >
            <SPicker x={x} isBig={isBig} pickerColor={pickerColor} />
            {options.map((option, idx) => (
              <SOption
                isBig={isBig}
                x={x}
                checked={input.value === option.value}
                key={idx}
                onClick={(e) => !disabled && onCheck(input, option, idx, e)}
              >
                {t(option.label)}
              </SOption>
            ))}
          </SSwitch>
        );
      }}
    </Field>
  );
};

const SSwitch = styled.div`
  && {
    width: ${({ isBig }) => (isBig ? '100%' : '200px')};
    z-index: 1;
    display: flex;
    background: ${({theme}) => theme.palette.colors.gray100};
    border: ${({ isBig, theme }) => (isBig ? `1px solid ${theme.palette.colors.gray200}` : 'none')};
    border-radius: 30px;
    overflow: hidden;
    height: ${({ isBig }) => (isBig ? '46px' : '40px')};
    align-items: center;
    font-size: 18px;
    color: #fff;
    position: relative;
    padding-right: ${({ isBig }) => (isBig ? '0' : '120px')};
    cursor: pointer;
  }
`;

const SOption = styled.div`
  && {
    cursor: pointer;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ isBig }) => (isBig ? '38px' : '40px')};
    width: ${({ isBig }) => (isBig ? '50%' : 'auto')};
    min-width: 100px;
    border-radius: 30px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: ${({ checked, theme }) => (checked ? theme.palette.colors.white : theme.palette.colors.black100)};
    transition: color 0.2s ease;
  }
`;
const SPicker = styled.div`
  && {
    z-index: 2;
    position: absolute;
    min-width: ${({ isBig }) => (isBig ? '50%' : '100px')};
    padding: ${({ isBig }) => (isBig ? '8px 55px' : '0')};
    height: ${({ isBig }) => (isBig ? '38px' : '40px')};
    border-radius: 30px;
    background-color: ${({ pickerColor, theme }) => pickerColor || theme.palette.colors.blue100};
    transform: ${({ x }) => `translateX(${x}px)`};
    transition: transform 200ms linear;
  }
`;

export default FormSwitch;
